import "@shared/publicPath.js";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@shared/index.css";

const mountNode = document.getElementById("root");

if (!mountNode) {
  throw new Error(
    'Missing #root element. Ensure index.html contains: <div id="root"></div>',
  );
}

ReactDOM.createRoot(mountNode).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
